import { Box, Button, Typography, useTheme } from '@mui/material';
import EastIcon from '@mui/icons-material/East';

export default function ArticleIntro({ article }) {
  const theme = useTheme();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        //position: 'absolute',
        padding: '0 16px 16px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        //color: theme.palette.root.basicWhite,
      }}
    >
      <Typography
        variant="boldBody1"
        sx={{
          textTransform: 'capitalize',
          marginBottom: '2px',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 1,
          lineClamp: 1,
          WebkitBoxOrient: 'vertical',
        }}
      >
        {article.title}
      </Typography>
      <Typography
        variant="body5"
        sx={{
          //marginBottom: '2px',
          //flexGrow: 1,
          lineHeight: 1.2,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          display: '-webkit-box',
          WebkitLineClamp: 2,
          lineClamp: 2,
          color: 'rgba(64, 64, 64, .6)',
          WebkitBoxOrient: 'vertical',
          [theme.breakpoints.down('sm')]: {
            WebkitLineClamp: 2,
            lineClamp: 2,
          },
        }}
      >
        {article.subtitle}
      </Typography>
      <Box
        sx={{ display: 'flex', alignItems: 'end', cursor: 'pointer', flexGrow: 1 }}
        onClick={() => {
          if (article.link.startsWith('http://') || article.link.startsWith('https://')) {
            window.open(article.link, '_blank');
          } else {
            window.open('http://' + article.link, '_blank');
          }
        }}
      >
        <Button
          variant='contained'
          sx={{
            padding: '0 24px',
            marginRight: '1px',
            height: '28px',
            backgroundColor: 'rgba(47, 229, 207, 1)',
            boxShadow: 'none',
            color: 'rgba(0, 71, 81, 1)',
            '&:hover': {
              backgroundColor: 'rgba(47, 229, 207, .5)',
              boxShadow: 'none',
            }
          }}>
          {article.buttonText}
        </Button>
        {/* <EastIcon sx={{ transform: 'scale(0.7)' }} /> */}
      </Box>
    </Box>
  );
}
